import { render, staticRenderFns } from "./FieldConfiguratorAccess.vue?vue&type=template&id=4d7b071e&"
import script from "./FieldConfiguratorAccess.vue?vue&type=script&lang=js&"
export * from "./FieldConfiguratorAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports